import { gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './TextItem.module.scss';

export interface TextItemProps {
    date: string;
    language_code: string;
}

export const TextItem = ({ date, language_code }: TextItemProps) => {
    const isEnglish = language_code === 'en';
    return (
        <>
            {isEnglish ? (
                <div className={styles.textContainer}>
                    <span className={styles.eventText}>{'Events'}</span>
                    &nbsp;
                    <span className={styles.dateText}>{date}</span>
                </div>
            ) : (
                <div>
                    <span className={styles.dateText}>
                        {gettext('Events %(date)s', { date })}
                    </span>
                </div>
            )}
        </>
    );
};
